"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closedMixin = exports.openedMixin = exports.leaveTransition = exports.enterTransition = exports.DRAWER_FOOTER_HEIGHT = exports.MENU_WIDTH_CLOSED = exports.MENU_WIDTH_OPEN = void 0;
// Might be better to add this to the theme. eg: theme.palette.menu.background
exports.MENU_WIDTH_OPEN = 280;
exports.MENU_WIDTH_CLOSED = 68;
exports.DRAWER_FOOTER_HEIGHT = 64;
const enterTransition = (theme) => theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
});
exports.enterTransition = enterTransition;
const leaveTransition = (theme) => theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
});
exports.leaveTransition = leaveTransition;
const openedMixin = (theme) => ({
    width: exports.MENU_WIDTH_OPEN,
    transition: (0, exports.enterTransition)(theme),
    overflowX: "hidden",
    background: theme.palette.background.paper,
});
exports.openedMixin = openedMixin;
const closedMixin = (theme) => ({
    transition: (0, exports.leaveTransition)(theme),
    overflowX: "hidden",
    width: exports.MENU_WIDTH_CLOSED,
    background: theme.palette.background.paper,
});
exports.closedMixin = closedMixin;
